import React, { FC, PropsWithChildren } from 'react';

import { ReactComponent as AlertIcon } from 'assets/images/svg/tooltip-alert.svg';

import { RouteDictionary } from '../../../utils';
import { CustomLink } from '../../common';

import './InvestNotice.scoped.scss';

interface Props {
  action?: {
    to: RouteDictionary;
    text: string;
  };
}

const InvestNotice: FC<PropsWithChildren<Props>> = ({ children, action }) => {
  return (
    <div className="invest-notice">
      <AlertIcon className="invest-notice__icon" />
      <div className="invest-notice__body">
        <span>{children}</span>
        {action && (
          <>
            {' '}
            <CustomLink className="invest-notice__action" to={action.to}>
              {action.text}
            </CustomLink>
          </>
        )}
      </div>
    </div>
  );
};

export default InvestNotice;
